<template>
  <FormItem
    class="full-name-input clearfix"
    label="姓名"
    :label-width="labelWidth"
    :prop="prop"
  >
    <Input
      size="large"
      :value="value.firstName"
      :disabled="disabled"
      placeholder="姓"
      @on-change="handleChange($event, 'firstName')"
    />
    <Input
      size="large"
      class="pull-right"
      :value="value.lastName"
      :disabled="disabled"
      placeholder="名"
      @on-change="handleChange($event, 'lastName')"
    />
  </FormItem>
</template>

<script>
  import { FormItem, Input } from 'iview';

  export default {
    components: { FormItem, Input },
    props: {
      prop: {
        type: String,
        default: ''
      },
      labelWidth: {
        type: Number,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        default: () => ({ firstName: '', lastName: '' })
      }
    },
    methods: {
      handleChange(e, key) {
        const payload = {
          ...this.value,
          [key]: e.target.value
        };
        this.$emit('input', payload);
      }
    }
  };
</script>